// The Mini App's start parameter (`https://t.me/<bot>?startapp=c<calendar id>`, the "Open in App" button under a posted list,
// built by `bot/app_link.py` in the backend, which uses the same `c<id>` shape).
export function parseStartParam(param: string | null | undefined): number | null {
  const match = /^c(\d{1,12})$/.exec(param ?? '')
  return match ? Number(match[1]) : null
}

// The parameter is acted on once per page load, so going back to the lists page afterwards stays there.
let consumed = false

export function takeStartCalendar(param: string | null | undefined): number | null {
  if (consumed) return null
  consumed = true
  return parseStartParam(param)
}

export function resetStartParam(): void {
  consumed = false
}
